<template>
    <ul class="fileList__list">
        <li class="fileList__item" v-for="document in documents">
            <a class="downloadFile" v-if="document.type === 'link'" :href="document.link" target="_blank">{{document.label}}</a>
        </li>
    </ul>
</template>

<script>
    export default {
        name:  'DownloadDocumentList',
        props: {
            documents: {
                type:    Array,
                default: [],
            },
            type:      {
                type:    String,
                default: null,
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/cad/DocumentList.vue